import * as React from 'react';
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";

type Props = {
  open: boolean,
  onClose?(): void,
  withoutOkButton?: boolean
};

export class UserNotReachableDialog extends React.Component<Props> {

  render() {
    return (
      <Dialog open={this.props.open} onClose={this.props.onClose}>
        <DialogTitle>Sorry!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The person you are trying to reach is temporarily not available.<br/>
            The person will be informed about your call.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!this.props.withoutOkButton && (
            <Button onClick={this.props.onClose} color="primary">
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

export default UserNotReachableDialog;
